// React Lib
import React, { useState } from "react";
// Component Styles
import { useStyles } from "./DirectoryStyles";
// @otg-one/ui_components/components
import { Typography } from '../index';
// @otg-one/ui_components/icons
import { Manage } from '../../icons';
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
export const Directory = (props) => {
    const classes = useStyles(props);
    const { id, icon, textLabel, isActive, disabled, onClick, style, backgroundStyle } = props;
    const [isHover, setIsHover] = useState(false);
    const handleOnMouseOver = () => setIsHover(true);
    const handleOnMouseOut = () => setIsHover(false);
    return (React.createElement("div", { style: Object.assign({ position: 'relative' }, style), id: id },
        React.createElement("div", { className: classes.directoryBackground, style: Object.assign({ background: disabled ? Color.neutral[700] : (isActive ? "linear-gradient(-90deg, rgb(0, 119, 182) 0%, rgb(0, 82, 127) 100%)" : (isHover ? Color.primary[400] : Color.primary[300])), cursor: disabled ? 'auto' : 'pointer', pointerEvents: disabled ? 'none' : 'auto' }, backgroundStyle), onClick: disabled ? undefined : onClick, onMouseOver: handleOnMouseOver, onMouseOut: handleOnMouseOut },
            icon,
            React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 24, color: Color.neutral[100] }, textLabel)),
        React.createElement("div", { className: classes.directorySeparator })));
};
Directory.defaultProps = {
    icon: React.createElement(Manage, null),
    textLabel: "Label",
    isActive: true,
    disabled: false,
    onClick: () => { },
};
export default React.memo(Directory);
